import React from 'react';
import { Card, CardContent } from '../../../../../components/card';
import { MerchantCouponUIState } from '../../data/merchantCouponEditor.data';
import { calculateCostSummary } from '../../utils/merchantCouponEditor.utils';

interface CostSummarySectionProps {
    coupon: MerchantCouponUIState;
}

export const CostSummarySection: React.FC<CostSummarySectionProps> = ({ coupon }) => {
    const summary = calculateCostSummary(coupon);

    return (
        <Card className="border border-[#00c49a] dark:border-emerald-500 border-l-4 bg-white dark:bg-gray-800 rounded-[10px]">
            <CardContent className="px-[28px] py-[24.8px]">
                {/* Header */}
                <div className="mb-3">
                    <h3 className="text-[16px] font-normal text-[#004232] dark:text-white leading-[24px]">
                        Cost Summary
                    </h3>
                </div>

                <div className="space-y-2">
                    {/* Total Coupons */}
                    <div className="flex items-start justify-between">
                        <span className="text-[14px] text-[#6e7670] dark:text-gray-400 leading-[21px]">
                            Total Coupons:
                        </span>
                        <span className="text-[14px] font-semibold text-[#004232] dark:text-white leading-[21px]">
                            {summary.totalCoupons}
                        </span>
                    </div>

                    {/* Discount Value */}
                    <div className="flex items-start justify-between">
                        <span className="text-[14px] text-[#6e7670] dark:text-gray-400 leading-[21px]">
                            Discount Value:
                        </span>
                        <span className="text-[14px] font-semibold text-[#004232] dark:text-white leading-[21px]">
                            {summary.discountValue}
                        </span>
                    </div>

                    {/* Campaign Period */}
                    <div className="flex items-start justify-between">
                        <span className="text-[14px] text-[#6e7670] dark:text-gray-400 leading-[21px]">
                            Campaign Period:
                        </span>
                        <span className="text-[14px] font-semibold text-[#004232] dark:text-white leading-[21px]">
                            {summary.campaignPeriod}
                        </span>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

